import { z } from "zod";

export const nameFormSchema = z.object({
  name: z.string().min(1, "Informe o nome"),
});

export type NameFormData = z.infer<typeof nameFormSchema>;

export const userFormSchema = z.object({
  username: z.string().min(1, "Informe o usuário"),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().email("Email inválido").or(z.literal("")),
});

export type UserFormData = z.infer<typeof userFormSchema>;
